<script async setup lang="ts">
import type { IAccoItem } from '@/composables/Interfaces/apiInterfaces'

const props = defineProps<{
  symbolClass: string
  rating: number
  isSuperior: boolean
}>()
</script>

<template>
  <div class="flex items-center gap-1">
    <div class="img-rating ml-[-4px]" :class="props.symbolClass" :style="'width: ' + props.rating * 22 + 'px'"></div>
    <span class="font-bold text-yellow-400" v-if="props.isSuperior">S</span>
  </div>
</template>

<style scoped>
.img-rating {
  background-repeat: no-repeat;
  height: 25px;
  background-size: 100px 25px;
  background-position: 6px 0;
}

.star {
  background-image: url('../../../../../assets/img/star_yellow.svg');
}

.flower {
  background-image: url('../../../../../assets/img/flower_yellow.svg');
}

.sun {
  background-image: url('../../../../../assets/img/sun_yellow.svg');
}
</style>
